import { render, staticRenderFns } from "./manage-training.vue?vue&type=template&id=3f43409c&"
import script from "./manage-training.vue?vue&type=script&lang=js&"
export * from "./manage-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports